import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { FaChevronRight } from 'react-icons/fa';
import { GetAllSitrepsForGroupResponse } from './hooks/useSitrepsV2';
import { selectAors, useAppSelector } from '../../slices/commonSelectors';

type SitrepSidebarItemProps = {
  sitrep: GetAllSitrepsForGroupResponse;
  onClick: () => void;
};

const SitrepListItem = ({ sitrep, onClick }: SitrepSidebarItemProps) => {
  const aors = useAppSelector(selectAors);
  const currentAorName = useMemo(
    () => aors.find((aor) => aor.id === sitrep.aor_id)?.name,
    [aors, sitrep.aor_id]
  );
  return (
    <button
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.target instanceof HTMLButtonElement) {
          // Prevent buttons in the row from triggering onClick for the row.
          return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      className="sitrep-list-item"
    >
      <div className="information-container">
        <div className="sitrep-name-container">
          <h6>{sitrep.name || 'Untitled Sitrep'}</h6>
        </div>
        <div className="sitrep-description-container">
          <p>
            <i>{sitrep.description || 'No description available'}</i>
          </p>
        </div>
        <div className="d-flex flex-wrap gap-2">
          {currentAorName && (
            <span className="badge bg-primary">{currentAorName}</span>
          )}
          {sitrep.timestamp && (
            <span className="badge bg-primary m-0 h6">
              {dayjs(sitrep.timestamp).format('MMM D, YYYY')}
            </span>
          )}
        </div>
      </div>
      <div className="arrow-container">
        <FaChevronRight />
      </div>
    </button>
  );
};

export default SitrepListItem;
